"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFromAndroidWebview = exports.getParamsLink = exports.UTM_expiry_days = exports.addDaysToEpochTime = exports.isGoogleUTMParams = exports.GoogleUtmParams = exports.StoreKey = exports.isEncrypted = exports.decrypt = exports.encrypt = exports.getCurrentURL = exports.applyStyle = exports.applyPadding = exports.applyMargin = exports.GoogleAnalytics = exports.ImportScript = exports.digioUtils = exports.getParameters = exports.EmptyTemplate = exports.getUniqueId = exports.getScreenType = exports.compareDeepDiff = exports.areEqualObjs = exports.isDiff = exports.PlatformSpecificScroll = exports.findDiff = exports.hasEqualProps = exports.arePropsEqual = void 0;
const types_1 = require("@voltmoney/types");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const react_native_1 = require("react-native");
const forEach_1 = __importDefault(require("lodash-es/forEach"));
const SharedPropsService_1 = __importDefault(require("../SharedPropsService"));
const react_native_crypto_js_1 = __importDefault(require("react-native-crypto-js"));
const filterProps = (props, allowedProps) => allowedProps.reduce((obj, key) => {
    obj[key] = props[key];
    return obj;
}, {});
const arePropsEqual = (allowedProps) => {
    return (nextProps, prevProps) => {
        const isEqual = (0, react_fast_compare_1.default)(filterProps(nextProps, allowedProps), filterProps(prevProps, allowedProps));
        return isEqual;
    };
};
exports.arePropsEqual = arePropsEqual;
const hasEqualProps = (nextProps, prevProps) => {
    const isEqual = (0, react_fast_compare_1.default)(nextProps, prevProps);
    return isEqual;
};
exports.hasEqualProps = hasEqualProps;
const findDiff = (nextProps, prevProps) => {
    if (!(0, react_fast_compare_1.default)(nextProps, prevProps)) {
        const diffKeys = [];
        (0, forEach_1.default)(Object.keys(nextProps), (key) => {
            if (!(0, react_fast_compare_1.default)(nextProps[key], prevProps[key])) {
                diffKeys.push(key);
            }
        });
        return diffKeys;
    }
    return [];
};
exports.findDiff = findDiff;
const PlatformSpecificScroll = () => {
    if (react_native_1.Platform.OS === 'web') {
        const url = window.location.href;
        const params = (0, exports.getParameters)(url);
        const _platform = params === null || params === void 0 ? void 0 : params.platform;
        switch (_platform) {
            case 'REDVISION':
                return false;
            default:
                return true;
        }
    }
    return false;
};
exports.PlatformSpecificScroll = PlatformSpecificScroll;
const isDiff = (prevProps, nextProps) => {
    if (!prevProps || !nextProps)
        return true;
    let hasDiff = false;
    Object.keys(nextProps).forEach((key) => {
        if (nextProps[key] !== prevProps[key]) {
            hasDiff = true;
        }
    });
    return hasDiff;
};
exports.isDiff = isDiff;
const areEqualObjs = (prevProps, nextProps) => {
    let diffCount = 0;
    let hasDiff = false;
    if (!nextProps)
        return hasDiff;
    if (!prevProps)
        return hasDiff;
    nextProps &&
        Object.keys(nextProps).forEach((key) => {
            hasDiff = nextProps[key] === prevProps[key];
            if (!hasDiff) {
                diffCount++;
            }
        });
    return hasDiff;
};
exports.areEqualObjs = areEqualObjs;
const compareDeepDiff = (prevProps, nextProps) => {
    let diffProps = {};
    let hasDiff = false;
    if (!nextProps)
        return diffProps;
    if (!prevProps)
        return diffProps;
    nextProps &&
        Object.keys(nextProps).forEach((key) => {
            hasDiff = nextProps[key] === prevProps[key];
            if (!hasDiff) {
                diffProps[key] = nextProps[key];
            }
        });
    return diffProps;
};
exports.compareDeepDiff = compareDeepDiff;
const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || react_native_1.Dimensions.get('window').width;
    if (screenWidthX < 576)
        return types_1.SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return types_1.SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return types_1.SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return types_1.SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return types_1.SCREEN_SIZE.X_LARGE;
    return types_1.SCREEN_SIZE.X_SMALL;
};
exports.getScreenType = getScreenType;
const getUniqueId = () => {
    return Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '')
        .substr(0, 5);
};
exports.getUniqueId = getUniqueId;
exports.EmptyTemplate = {
    layout: {
        id: 'empty_template',
        type: types_1.LAYOUTS.LIST,
        widgets: [],
    },
    datastore: {},
};
const getParameters = () => {
    if (react_native_1.Platform.OS === 'web') {
        const url = window.location.href;
        const params = {};
        const paramString = url.split('?')[1];
        const queryString = new URLSearchParams(paramString);
        //@ts-ignore
        for (const pair of queryString.entries()) {
            //@ts-ignore
            params[pair[0].includes('/')
                ? pair[0].split('/')[1]
                : pair[0]] = pair[1].includes('/')
                ? pair[1].split('/')[0]
                : pair[1];
        }
        console.warn('PLATFORM params returned $$$$', params);
        return params;
    }
    else {
        return {};
    }
};
exports.getParameters = getParameters;
exports.digioUtils = {
    init: () => {
        //@ts-ignore
        const digio = window.digio;
        digio && digio.init();
    },
    submit: (requestId, identifier, token_id) => {
        //@ts-ignore
        const digio = window.digio;
        digio &&
            digio.submit(requestId, identifier, token_id);
    },
};
const ImportScript = (resourceUrl, customFunction, successCB, failureCB, origin) => {
    const script = document.createElement('script');
    script.src = resourceUrl;
    script.async = false;
    document.body.appendChild(script);
    script.onload = () => {
        if (successCB && failureCB) {
            customFunction &&
                customFunction(successCB, failureCB, origin);
        }
        else {
            customFunction && customFunction();
        }
    };
};
exports.ImportScript = ImportScript;
exports.GoogleAnalytics = {
    sendEvent: (eventId, params, eventType) => {
        console.log('Pushed in data layer', eventType);
        if (!eventType) {
            eventType = types_1.AnalyticsEventType.EventTracking;
        }
        // @ts-ignore
        // window.dataLayer.push(params);
        // window.gtag('event', routeId, params);
        switch (eventType) {
            case types_1.AnalyticsEventType.EventTracking:
                //@ts-ignore
                // window.gtag('event', routeId, params);
                window.dataLayer.push({
                    event: eventId,
                    eventProps: Object.assign({}, params),
                });
                break;
            case types_1.AnalyticsEventType.PageTracking:
                params
                    ? //@ts-ignore
                        // window.gtag('event', routeId, params)
                        window.dataLayer.push({
                            event: eventId,
                            page: Object.assign({}, params),
                        })
                    : //@ts-ignore
                        window.dataLayer.push({
                            event: eventId,
                        });
                break;
        }
    },
};
const applyMargin = (padding) => {
    let style = {};
    if (!padding)
        return style;
    if (padding.all || padding.all === 0) {
        style = Object.assign(Object.assign({}, style), { margin: padding.all });
    }
    if (padding.left || padding.left === 0) {
        style = Object.assign(Object.assign({}, style), { marginLeft: padding.left });
    }
    if (padding.right || padding.right === 0) {
        style = Object.assign(Object.assign({}, style), { marginRight: padding.right });
    }
    if (padding.top || padding.top === 0) {
        style = Object.assign(Object.assign({}, style), { marginTop: padding.top });
    }
    if (padding.bottom || padding.bottom === 0) {
        style = Object.assign(Object.assign({}, style), { marginBottom: padding.bottom });
    }
    if (padding.horizontal ||
        padding.horizontal === 0) {
        style = Object.assign(Object.assign({}, style), { marginHorizontal: padding.horizontal });
    }
    if (padding.vertical || padding.vertical === 0) {
        style = Object.assign(Object.assign({}, style), { marginVertical: padding.vertical });
    }
    return style;
};
exports.applyMargin = applyMargin;
const applyPadding = (padding) => {
    let style = {};
    if (!padding)
        return style;
    if (padding.all || padding.all === 0) {
        style = Object.assign(Object.assign({}, style), { padding: padding.all });
    }
    if (padding.left || padding.left === 0) {
        style = Object.assign(Object.assign({}, style), { paddingLeft: padding.left });
    }
    if (padding.right || padding.right === 0) {
        style = Object.assign(Object.assign({}, style), { paddingRight: padding.right });
    }
    if (padding.top || padding.top === 0) {
        style = Object.assign(Object.assign({}, style), { paddingTop: padding.top });
    }
    if (padding.bottom || padding.bottom === 0) {
        style = Object.assign(Object.assign({}, style), { paddingBottom: padding.bottom });
    }
    if (padding.horizontal ||
        padding.horizontal === 0) {
        style = Object.assign(Object.assign({}, style), { paddingHorizontal: padding.horizontal });
    }
    if (padding.vertical || padding.vertical === 0) {
        style = Object.assign(Object.assign({}, style), { paddingVertical: padding.vertical });
    }
    return style;
};
exports.applyPadding = applyPadding;
const applyStyle = (position) => {
    switch (position) {
        case types_1.POSITION.CENTER: {
            return { alignSelf: 'center' };
        }
        default:
            return {};
    }
};
exports.applyStyle = applyStyle;
const getCurrentURL = () => {
    let url = SharedPropsService_1.default.getConfig(types_1.CONFIG_KEYS.CURRENT_URL_ADDRESS);
    /*** Manually extract params from URL ***/
    if (!url) {
        url =
            react_native_1.Platform.OS === 'web'
                ? window.location.href
                : '';
        SharedPropsService_1.default.setConfig(types_1.CONFIG_KEYS.CURRENT_URL_ADDRESS, url);
    }
    return url;
};
exports.getCurrentURL = getCurrentURL;
const encrypt = (text) => __awaiter(void 0, void 0, void 0, function* () {
    if (!text) {
        return '';
    }
    const ivMaterial = 'globalaesvectors';
    const keyMaterial = 'jXn2r5u8x/A?D(G+KbPeSgVkYp3s6v9y';
    let key = react_native_crypto_js_1.default.enc.Utf8.parse(keyMaterial);
    let iv = react_native_crypto_js_1.default.enc.Utf8.parse(ivMaterial);
    let ciphertext1 = react_native_crypto_js_1.default.AES.encrypt(text, key, { iv: iv, padding: react_native_crypto_js_1.default.pad.Pkcs7 }); // default values: CBC, PKCS#7 padding
    return react_native_crypto_js_1.default.enc.Base64.stringify(ciphertext1.ciphertext);
});
exports.encrypt = encrypt;
const decrypt = (text) => __awaiter(void 0, void 0, void 0, function* () {
    if (!text) {
        return '';
    }
    text = text.replace('-', '+').replace('_', '/');
    const decodedText = react_native_crypto_js_1.default.enc.Base64.parse(text);
    const ivMaterial = 'globalaesvectors';
    const keyMaterial = 'G-KaPdSgVkYp3s5v8y/B?E(H+MbQeThW';
    let key = react_native_crypto_js_1.default.enc.Utf8.parse(keyMaterial);
    let iv = react_native_crypto_js_1.default.enc.Utf8.parse(ivMaterial);
    let ciphertext1 = react_native_crypto_js_1.default.AES.decrypt({
        ciphertext: decodedText,
    }, key, {
        iv: iv,
        padding: react_native_crypto_js_1.default.pad.Pkcs7,
    }); // default values: CBC, PKCS#7 padding
    const result = react_native_crypto_js_1.default.enc.Utf8.stringify(ciphertext1);
    return result;
});
exports.decrypt = decrypt;
const isEncrypted = (url) => {
    if (url.startsWith('https://api.voltmoney.in')) {
        return true;
    }
    else {
        return false;
    }
};
exports.isEncrypted = isEncrypted;
exports.StoreKey = {
    isPledgeFirstTime: 'isPledgeFirstTime',
    isLoadedFirstTime: 'is_Loaded_First_Time',
    accessToken: 'access_token',
    refreshToken: 'refresh_token',
    userContext: 'user_context',
    urlWithDate: 'url_with_date',
    UTM_PARAMS: 'UTM_PARAMS',
    APP_PLATFORM: 'APP_PLATFORM',
    Platform_leads: 'Platform_leads',
    PLATFORM_ACTIVE_CUSTOMERS: 'PLATFORM_ACTIVE_CUSTOMERS',
    PLATFORM_LINKED_PARTNERS: 'PLATFORM_LINKED_PARTNERS',
    PLJ_borrowerAccountId: 'PLJ_borrowerAccountId',
    PLATFORM_AUTH_TOKEN: 'platformAuthToken',
    LEAD_TOKEN: 'lead_token',
    U_DATA: 'u_data',
    CONTEXT: 'CONTEXT',
    EXTERNAL_ROUTE: 'external_route',
    SDK_CONFIG: 'SDK_CONFIG'
};
var GoogleUtmParams;
(function (GoogleUtmParams) {
    GoogleUtmParams["UTM_CAMPAIGN"] = "utm_campaign";
    GoogleUtmParams["UTM_CONTENT"] = "utm_content";
    GoogleUtmParams["UTM_ID"] = "utm_id";
    GoogleUtmParams["UTM_MEDIUM"] = "utm_medium";
    GoogleUtmParams["UTM_SOURCE"] = "utm_source";
})(GoogleUtmParams = exports.GoogleUtmParams || (exports.GoogleUtmParams = {}));
const isGoogleUTMParams = param => {
    if (param === GoogleUtmParams.UTM_SOURCE ||
        param === GoogleUtmParams.UTM_CONTENT ||
        param === GoogleUtmParams.UTM_ID ||
        param === GoogleUtmParams.UTM_CAMPAIGN ||
        param === GoogleUtmParams.UTM_MEDIUM) {
        return true;
    }
    return false;
};
exports.isGoogleUTMParams = isGoogleUTMParams;
const addDaysToEpochTime = (epochTime, days) => {
    const date = new Date(epochTime);
    const dateAfterAddingDays = date.setDate(date.getDate() + days);
    return dateAfterAddingDays.valueOf();
};
exports.addDaysToEpochTime = addDaysToEpochTime;
exports.UTM_expiry_days = 28;
const getParamsLink = (url) => {
    const params = react_native_1.Platform.OS === 'web' && url ? (0, exports.getParameters)(url) : {};
    let resultString = '';
    let localStoredParams = {};
    // check if params exist in localstorage if not present in query string
    const utm_campaign = params === null || params === void 0 ? void 0 : params.utm_campaign;
    const utm_content = params === null || params === void 0 ? void 0 : params.utm_content;
    const utm_id = params === null || params === void 0 ? void 0 : params.utm_id;
    const utm_medium = params === null || params === void 0 ? void 0 : params.utm_medium;
    const utm_source = params === null || params === void 0 ? void 0 : params.utm_source;
    const cachedUtm = localStorage.getItem(exports.StoreKey.UTM_PARAMS);
    console.log("params object 123: ", params);
    if (utm_campaign || utm_content || utm_id || utm_medium || utm_source) {
        Object.keys(params).forEach(param => {
            //store google utm params in localStorage
            if ((0, exports.isGoogleUTMParams)(param)) {
                localStoredParams = Object.assign(Object.assign({}, localStoredParams), { time: (0, exports.addDaysToEpochTime)(Date.now().valueOf(), exports.UTM_expiry_days), [`${param}`]: params[param] });
            }
            if (param !== 'time') {
                console.log("param 123: ", param);
                resultString += `${param}=${params[`${param}`]}&`;
            }
        });
        localStorage.removeItem(exports.StoreKey.UTM_PARAMS);
        localStoredParams &&
            localStorage.setItem(exports.StoreKey.UTM_PARAMS, JSON.stringify(localStoredParams));
    }
    else {
        if (cachedUtm) {
            const cachedUtmJson = JSON.parse(cachedUtm);
            if ((cachedUtmJson === null || cachedUtmJson === void 0 ? void 0 : cachedUtmJson.time) && Date.now().valueOf() <= cachedUtmJson.time) {
                Object.keys(cachedUtmJson).forEach(param => {
                    //store google utm params in localStorage
                    if (param === 'time') {
                        //
                    }
                    else {
                        resultString += `${param}=${cachedUtmJson[`${param}`]}&`;
                    }
                });
            }
            else {
                //remove google utm params in localStorage when token expires
                localStorage.removeItem(exports.StoreKey.UTM_PARAMS);
            }
        }
        else {
            Object.keys(params).forEach(param => {
                //store google utm params in localStorage
                resultString += `${param}=${params[`${param}`]}&`;
            });
        }
    }
    return `?${resultString}`;
};
exports.getParamsLink = getParamsLink;
const isFromAndroidWebview = () => {
    const isWebView = navigator.userAgent.includes('wv');
    console.warn("IS FROM WEBVIEW", isWebView);
    return isWebView;
};
exports.isFromAndroidWebview = isFromAndroidWebview;
//# sourceMappingURL=utils.js.map